module.exports = __webpack_public_path__ + "static/media/introduce_more3.637f0f7d.png";